module.exports = __webpack_public_path__ + "static/myconid_adult-8272633a5a868040fe28cc6e3f637e97.jpg";